export const environment = {
  production: true,
  authConfig: {
    baseUrl: 'https://www.freelancer.com/auth',
    authHashCookie: 'GETAFREE_AUTH_HASH_V2',
    userIdCookie: 'GETAFREE_USER_ID',
  },
  uiConfig: {
    assetsBaseUrl: 'https://www.f-cdn.com/assets/webapp/assets',
    locale: 'th',
  },
  datastoreConfig: {
    apiBaseUrl: 'https://www.freelancer.com/api',
    ajaxBaseUrl: 'https://www.freelancer.com/ajax-api',
    webSocketUrl: 'https://notifications.freelancer.com',
    enableStoreFreeze: false,
  },
  trackingConfig: {
    trackingEndpoint: 'https://t.freelancer.com/0px.gif',
    sessionCookie: '_tracking_session',
    navigationPerformanceSamplingRate: 1,
    enableErrorTracking: true,
    sentryDsn: 'https://89961363a0f642558f5fedad5195eb89@sentry.io/85230',
    gitRevision: '7d73fe6',
    buildDate: 'Fri Nov 03 2017 02:37:04 GMT-0400 (EDT)',
  },
  billingConfig: {
    baseUrl: 'https://api.flnbln.net',
  },
  facebookAppId: '',
  languageCookie: 'GETAFREE_LANGUAGE',
};



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/th/webapp/src/environments/environment.ts